import { z } from 'zod';
import { CategoryDefinitionView, CategoryListQuery, InterestOptionView, InterestQuery, } from '../../taxonomy.js';
/**
 * The runtime taxonomy the apps render from (FR-ADM-60, FR-ADM-62).
 *
 * Read-only here on purpose: members consume the registry, Super Admins edit
 * it through the admin manifest. Both endpoints are public — a signed-out
 * member still has to be shown the Area of Interest checkboxes during signup.
 */
export const taxonomyRoutes = {
    /**
     * Category-1 definitions in display order, each carrying the field list for
     * its "Account Settings" screen. The four design screens are one component
     * driven by this response, so a fifth category needs no app release.
     */
    categories: {
        method: 'GET',
        path: '/taxonomy/categories',
        query: CategoryListQuery,
        response: z.array(CategoryDefinitionView),
    },
    /** The "What I Like" chips, optionally narrowed to one category. */
    interests: {
        method: 'GET',
        path: '/taxonomy/interests',
        query: InterestQuery,
        response: z.array(InterestOptionView),
    },
};
//# sourceMappingURL=routes.js.map